import { useLinkedAccounts } from "@store/linkedAccountSlice";
import { ClipLoading } from "@src/ui/Loading";
import { LinkedAccounts } from "./LinkedAccounts";
import { AddLinkAccount } from "./AddLinkAccount";

export function LinkedAccountGuard() {
  const { status, items } = useLinkedAccounts();
  const hasLinkedAccount = items.length > 0;

  if (status === "idle" || status === "loading") {
    return <ClipLoading className="min-h-[360px]" />;
  }

  return hasLinkedAccount ? <LinkedAccounts /> : <AddLinkAccount />;
}
